import { _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var init_meta = {
  customerType: "Individual",
  detailLevel: "Lite",
  custCreated: false
};
var init_state = {
  cust_number: "",
  indv_lite: {
    title: "",
    firstName: "",
    surName: "",
    mobile: "",
    email: "",
    dob: "",
    comm_city: "",
    comm_pincode: "",
    comm_district: "",
    comm_state: ""
  },
  indv_detail: {
    title: "",
    gender: "",
    dob: "",
    firstName: "",
    surName: "",
    middleName: "",
    maritalStatus: "",
    occupation: "",
    other_occupation: "",
    mother_maiden_name: "",
    ckyc_id_number: "",
    eia_required: "",
    eia_number: "",
    nationality: "",
    id_proof_type: "",
    id_proof_no: "",
    pan_no: "",
    gst_no: "",
    perm_address1: "",
    perm_address2: "",
    perm_address3: "",
    perm_landmark: "",
    perm_city: "",
    perm_pincode: "",
    perm_district: "",
    perm_state: "",
    comm_perm_same: false,
    comm_address1: "",
    comm_address2: "",
    comm_address3: "",
    comm_landmark: "",
    comm_city: "",
    comm_pincode: "",
    comm_district: "",
    comm_state: "",
    cont_tel: "",
    cont_mob: "",
    cont_email: "",
    fax: "",
    alt_tel: "",
    alt_mob: "",
    bankName: "",
    branchName: "",
    ifscCode: "",
    acc_no: "",
    employee_number: ""
  },
  org_lite: {
    orgName: "",
    orgType: "",
    contactPerson: "",
    contactMobile: "",
    contactEmail: "",
    comm_city: "",
    comm_pincode: "",
    comm_district: "",
    comm_state: ""
  },
  org_detail: {
    orgName: "",
    orgType: "",
    contactPerson: "",
    reg_no: "",
    tan_no: "",
    gst_no: "",
    ckyc_id_number: "",
    udyog_aadhaar_number: "",
    certificate_of_incorporation: "",
    perm_address1: "",
    perm_address2: "",
    perm_address3: "",
    perm_landmark: "",
    perm_city: "",
    perm_pincode: "",
    perm_district: "",
    perm_state: "",
    comm_perm_same: false,
    comm_address1: "",
    comm_address2: "",
    comm_address3: "",
    comm_landmark: "",
    comm_city: "",
    comm_pincode: "",
    comm_district: "",
    comm_state: "",
    cont_tel: "",
    cont_mob: "",
    cont_email: "",
    fax: "",
    alt_tel: "",
    alt_mob: "",
    bankName: "",
    branchName: "",
    ifscCode: "",
    acc_no: ""
  }
};
var createCustMetaVar = makeVar(init_meta);
var createCustVar = makeVar(init_state);
var initCreateCustState = function initCreateCustState() {
  createCustVar(init_state);
};
var initCreateCustMetaState = function initCreateCustMetaState() {
  createCustMetaVar(init_meta);
};
var updateMeta = function updateMeta(data) {
  return createCustMetaVar(_objectSpread2(_objectSpread2({}, createCustMetaVar()), data));
};
var updateIndvLite = function updateIndvLite(data) {
  return createCustVar(_objectSpread2(_objectSpread2({}, createCustVar()), {}, {
    indv_lite: data
  }));
};
var updateIndvDetail = function updateIndvDetail(data) {
  return createCustVar(_objectSpread2(_objectSpread2({}, createCustVar()), {}, {
    indv_detail: _objectSpread2(_objectSpread2({}, createCustVar().indv_detail), data)
  }));
};
var updateOrgLite = function updateOrgLite(data) {
  return createCustVar(_objectSpread2(_objectSpread2({}, createCustVar()), {}, {
    org_lite: data
  }));
};
var updateOrgDetail = function updateOrgDetail(data) {
  return createCustVar(_objectSpread2(_objectSpread2({}, createCustVar()), {}, {
    org_detail: data
  }));
};
var updateCustNumber = function updateCustNumber(cust_number) {
  return createCustVar(_objectSpread2(_objectSpread2({}, createCustVar()), {}, {
    cust_number: cust_number
  }));
};

export { createCustMetaVar as a, updateIndvDetail as b, createCustVar as c, updateOrgLite as d, updateOrgDetail as e, updateCustNumber as f, updateMeta as g, initCreateCustMetaState as h, initCreateCustState as i, updateIndvLite as u };
